<template>
	<div style="width: 100%;">
		<dms-row>
			<dms-col :lg="6">
				<el-input v-model="localizationText" clearable @focus="clearExcept('localizationText')" />
			</dms-col>
			<dms-col :lg="6">
				<el-input v-model="localizationPath" clearable @focus="clearExcept('localizationPath')" />
			</dms-col>
			<dms-col :lg="6">
				<el-input v-model="localizationZkratka" clearable @focus="clearExcept('localizationZkratka')" />
			</dms-col>
			<dms-col :lg="6">
				<el-input v-model="localizationHint" clearable @focus="clearExcept('localizationHint')" />
			</dms-col>
		</dms-row>
		<el-table :data="translatedKey">
			<el-table-column prop="text" label="Text" />
			<el-table-column label="Key Path">
				<template slot-scope="scope">
					{{ scope.row.prefix }}.{{ scope.row.key }}
				</template>
			</el-table-column>
			<el-table-column prop="zkratka" label="Zkratka" />
			<el-table-column prop="hint" label="Hint" />
		</el-table>
	</div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'DmsDevLocalizationKey',
	data() {
		return {
			localizationText: '',
			localizationPath: '',
			localizationZkratka: '',
			localizationHint: '',
		};
	},
	computed: {
		preprocessedTexts() {
			const result = [];
			const { localization } = this.$store.state;

			const appendTextObject = (prefix) => (key) => {
				const textObj = localization[prefix][key];
				result.push({
					prefix,
					key,
					text: textObj.Text,
					zkratka: textObj.TextZkratka,
					hint: textObj.TextHint,
				});
			};

			const appendPlainText = (prefix) => (key) => {
				result.push({
					prefix,
					key,
					text: localization[prefix][key],
				});
			};

			Object.keys(localization.Popispoli).forEach(appendTextObject('Popispoli'));
			Object.keys(localization.Popisostatni).forEach(appendTextObject('Popisostatni'));
			Object.keys(localization.ChyboveHlasky).forEach(appendTextObject('ChyboveHlasky'));

			Object.keys(localization.Menu).forEach(appendPlainText('Menu'));
			Object.keys(localization.Formular).forEach(appendPlainText('Formular'));

			return result;
		},
		translatedKey() {
			function filterBy(result, filterFieldName, localizationObjFieldName) {
				if (this[filterFieldName]) {
					const searchString = this[filterFieldName].toLowerCase();
					return result.filter((it) => it[localizationObjFieldName]
                            && it[localizationObjFieldName].toLowerCase().startsWith(searchString));
				}
				return result;
			}

			if (this.localizationText || this.localizationPath
                    || this.localizationZkratka || this.localizationHint) {
				let result = this.preprocessedTexts;

				result = filterBy.call(this, result, 'localizationText', 'text');
				result = filterBy.call(this, result, 'localizationPath', 'key');
				result = filterBy.call(this, result, 'localizationZkratka', 'zkratka');
				result = filterBy.call(this, result, 'localizationHint', 'hint');

				return result;
			}
			return [];
		},
	},
	methods: {
		clearExcept(activeField) {
			const toClear = ['localizationText', 'localizationPath', 'localizationZkratka', 'localizationHint'];

			toClear.forEach((field) => {
				if (field !== activeField) this[field] = '';
			});
		},
	},
});
</script>
